import { type NavigationError } from "@angular/router";

const CHUNK_LOAD_ERROR_MESSAGES = [
  "Failed to fetch dynamically imported module",
  "Importing a module script failed",
  "error loading dynamically imported module",
];

const RELOAD_AT_KEY = "oct-chunk-load-reload-at";
const RELOAD_COOLDOWN_MS = 60000;

function isChunkLoadError(error: unknown) {
  return (
    error instanceof TypeError &&
    CHUNK_LOAD_ERROR_MESSAGES.some(message => error.message.includes(message))
  );
}

function reloadedRecently() {
  const lastReloadAt = Number(
    window.sessionStorage.getItem(RELOAD_AT_KEY) ?? "0"
  );

  return Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS;
}

export function recoverFromChunkLoadError(navigationError: NavigationError) {
  if (!isChunkLoadError(navigationError.error) || reloadedRecently()) return;

  window.sessionStorage.setItem(RELOAD_AT_KEY, Date.now().toString());
  window.location.assign(navigationError.url);
}
